import { Provider } from '@angular/core';
import { FilterTemplateRepository } from './repositories/filter-template.repository';
import { LocalStorageFilterTemplateRepository } from './repositories/local-storage-filter-template.repository';

export const SOFTLINE_TRANSLATION_MODULE_CORE_FILTER = 'core-filter';

/**
 * Optional override hook: pageFilter() falls back to the LocalStorage
 * repository on its own, so apps only provide this token to replace the
 * storage (e.g. a future backend implementation).
 */
export function provideFilterTemplates(): Provider[] {
  return [{ provide: FilterTemplateRepository, useClass: LocalStorageFilterTemplateRepository }];
}
